import {
  PolicyDeliveryStore,
  PolicyDeliveryResponse,
  POLICY_DELIVERY_DOWNLOAD_FAILED,
  POLICY_DELIVERY_DOWNLOAD_START,
  POLICY_DELIVERY_DOWNLOAD_SUCCESS,
  POLICY_DELIVERY_FAILED,
  POLICY_DELIVERY_START,
  POLICY_DELIVERY_SUCCESS
} from './types';

export const policyDelivery = (
  state: PolicyDeliveryStore = {
    deliveryFetched: false
  },
  action: {
    type: string;
    payload?: unknown;
  }
): PolicyDeliveryStore => {
  switch (action.type) {
    case POLICY_DELIVERY_START:
      return {
        ...state,
        deliveryFetched: false,
        deliveryError: null,
        data: null
      };
    case POLICY_DELIVERY_SUCCESS: {
      return {
        ...state,
        deliveryFetched: true,
        data: action.payload as PolicyDeliveryResponse[]
      };
    }
    case POLICY_DELIVERY_FAILED:
      return { ...state, deliveryFetched: true, deliveryError: action.payload };
    case POLICY_DELIVERY_DOWNLOAD_START:
      return {
        ...state,
        reqPolRefNumber: action.payload as string,
        confirmationError: null,
        confirmationFetching: true
      };
    case POLICY_DELIVERY_DOWNLOAD_SUCCESS:
      return {
        ...state,
        confirmationFetching: false,
        confirmationError: null,
        confirmationData: {
          ...state.confirmationData,
          [state.reqPolRefNumber]: action.payload as Blob
        }
      };
    case POLICY_DELIVERY_DOWNLOAD_FAILED: {
      return {
        ...state,
        confirmationFetching: false,
        confirmationError: action.payload
      };
    }
    default:
      return {
        ...state,
        reqPolRefNumber: null
      };
  }
};
